import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { PageState } from '@app-core/models/_enums';
import { AppState } from '@app-core/models/app-state';
import { IDecryptResponse } from '@app-core/models/decrypt-response';
import { ApiService } from '@app-core/services/api.service';
import { StateService } from '@app-core/services/state.service';
import { EMPTY, Observable, Subscription } from 'rxjs';
import { filter, switchMap, withLatestFrom } from 'rxjs/operators';
import { CardDetails } from '@app-pages/models/card-details';

@Component({
  selector: 'app-root',
  template: `
    <div class="content">
    	<div *ngIf="(hasLocalStorageError$ | async); else default" class="container container--section container--article container--clearHeader">
    		<div class="grid">
    			<div class="grid__unit s-4-4 m-12-12 l-7-12 l-push-left-1-12">
    				<h1 class="h1">{{ 'LOCALSTORAGE.TITLE' | translate }}</h1>
    				<p [innerHtml]="'LOCALSTORAGE.BODY' | translate "></p>
    				<hr class="articleSeparator">
    					<h3 class="h3">{{ 'LOCALSTORAGE.LINKS.TITLE' | translate }}</h3>
    					<ul class="list">
    						<li class="list__item">
    							<a href="https://www.ns.nl" class="arrowLink">{{ 'LOCALSTORAGE.LINKS.HOMEPAGE' | translate }}</a>
    						</li>
    						<li class="list__item">
    							<a href="https://www.ns.nl/reisinformatie" class="arrowLink">{{ 'LOCALSTORAGE.LINKS.JOURNEY_PLANNER' | translate }}</a>
    						</li>
    						<li class="list__item">
    							<a href="https://www.ns.nl/klantenservice" class="arrowLink">{{ 'LOCALSTORAGE.LINKS.CUSTOMER_SERVICE' | translate }}</a>
    						</li>
    					</ul>
    				</div>
    			</div>
    		</div>
    		<ng-template #default>
    			<div class="container container--section container--article container--clearHeader">
    				<app-landings-page *ngIf="(appState$ | async)?.currentPageState === PageState.LANDINGS_PAGE"></app-landings-page>
    				<app-upload-page *ngIf="(appState$ | async)?.currentPageState === PageState.UPLOAD_PAGE"></app-upload-page>
    				<app-thanks-page *ngIf="(appState$ | async)?.currentPageState === PageState.THANKS_PAGE"></app-thanks-page>
    			</div>
    		</ng-template>
    	</div>`
})
export class AppComponent implements OnDestroy {
  appState$: Observable<AppState>;
  hasLocalStorageError$: Observable<boolean>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  PageState: any = PageState;

  subscriptions = new Subscription();

  constructor(
    private _stateService: StateService,
    private _activatedRoute: ActivatedRoute,
    private _apiService: ApiService
  ) {
    this.appState$ = this._stateService.getState$();
    this.hasLocalStorageError$ = this._stateService.hasLocalStorageError$();

    this.subscriptions.add(
      this._activatedRoute.queryParams
        .pipe(
          filter((params: Params) => params['token'] != null),
          withLatestFrom(this.appState$),
          switchMap(([params, currentState]) => {
            const { currentPageState } = currentState;
            return currentPageState !== PageState.UPLOAD_PAGE
              ? this._apiService.decryptToken(params['token'])
              : EMPTY;
          })
        )
        .subscribe(({ cardDetails, succes }: IDecryptResponse) => {
          this._stateService.updateState(
            {
              currentPageState: PageState.LANDINGS_PAGE,
              cardDetails: succes ? cardDetails : new CardDetails()
            },
            true,
            false
          );
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
